import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AudioInputTest, VideoInputTest } from "@twilio/rtc-diagnostics";
import { DIAGNOSTIC_STEP_PERMISSION_ERROR_VALUE } from "@/constants/diagnostics";
import { ErrorTypes, IDiagnosticsError, IDiagnosticsState } from "./types";

const initialState: IDiagnosticsState = {
  step: 0,
  error: null,
  videoTestReport: null,
  audioInputTestReport: null,
};

const diagnosticsSlice = createSlice({
  name: "Diagnostics",
  initialState,
  reducers: {
    setDiagnosticsStep(state, action: PayloadAction<number>) {
      state.step = action.payload;
    },
    setDiagnosticsError(state, action: PayloadAction<IDiagnosticsError>) {
      state.error = action.payload;

      switch (action.payload.type) {
        case ErrorTypes.permissions:
          state.step = DIAGNOSTIC_STEP_PERMISSION_ERROR_VALUE;
          break;
      }
    },
    setDiagnosticsVideoTestReport(state, action: PayloadAction<VideoInputTest.Report>) {
      state.videoTestReport = action.payload;
    },
    setDiagnosticsAudioInputTestReport(state, action: PayloadAction<AudioInputTest.Report>) {
      state.audioInputTestReport = action.payload;
    },
  },
});

export const {
  setDiagnosticsStep,
  setDiagnosticsError,
  setDiagnosticsVideoTestReport,
  setDiagnosticsAudioInputTestReport,
} = diagnosticsSlice.actions;

export default diagnosticsSlice.reducer;
